import { Component, OnInit } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-color',
  templateUrl: './create-color.component.html',
  styleUrls: ['./create-color.component.scss'],
})
export class CreateColorComponent {
  loader: boolean = false;
  name;
  editBool: boolean = false;
  id;
  item: any;
  activeInd: boolean = true;
  category;
  cateName;
  cateId;
  qty;
  fontStyle;
  serviceTypeObj = [{ id: 1, name: "Org Service" },
  { id: 3, name: "Ads Service" }];
  serviceTypeId: any = 1;
  serviceTypeName: any = "Org Service";
  pic: any;
  data: any;
  productName;
productId;
productObj:any;
  description;
  code;
  constructor(public service: ApiService,
    public handler: HandlerService,
    private bottomSheet: MatBottomSheet,
    public router: Router) { }

  ionViewWillEnter() {
    this.fontStyle = localStorage.getItem('lang')
    let url = window.location.href;
    this.id = window.location.href.split('/').pop();
    this.getProductObject();
    

    if (url.includes('edit')) {
      this.editBool = true;
      this.id = window.location.href.split('/').pop();
      this.service.getcolorById(this.id).subscribe((res: any) => {
        this.item=res;
        this.name = res.name;
        this.code = res.code;
        this.activeInd = res.activeInd;
        this.cateId=res.purchaseCategoryId;
        this.productId-res.productId;
        setTimeout(() => {
          this.category.map(res1 => {
            if (res1.id == this.cateId) {
              this.cateName = res1.name;
              this.cateId = res1.id;
            }
          })
        }, 1000);
        setTimeout(() => {
          this.productObj.map(dat=>{
            if(dat.id==this.productId){
             this.productName = dat.name
            }
          }) 
        }, 1000);
      },
        err => {
          this.handler.err(err);
          this.loader = false;
        })

    }
    else {
      this.editBool = false;
    }

  }

  getCategory(){
    this.service.getAllPurchaseCategory().subscribe((res:any)=>{
      this.category=res;
      this.category.map(dat=>{
        if(dat.id==this.cateId){
          this.cateName = dat.name;
        }
      })
      this.loader=false;
    })
  }
  
  openBottomSheet(){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;  
        }
    });
  }

  getProductObject(){
    this.service.getAllProduct().subscribe(res => {
      this.productObj = res;
      this.getCategory();
    })
  }

    openBottomSheetProduct() {
      this.productObj=this.productObj.filter(res=>{return this.cateId==res.purchaseCategoryId})
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.productObj,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if (res) {
          this.productName = res.name;
          this.productId = res.id;
        }
      });
    }

  create() {
    if(this.cateId && this.productId){
    this.loader = true;
    var post = {
      "name": this.name,
      "code": this.code,
      "activeInd": true,
      "purchaseCategoryId":this.cateId,
      "productId":this.productId
    }

    this.service.createcolor(post).subscribe(res => {
      this.handler.res("Color Created Successfully");
      this.loader = false;
      this.router.navigate(['/manage-color'])

    },
      err => {
        this.loader = false;
        this.handler.err(err);

      })
    }else{
      this.handler.err('Please Enter Required Fields')
    }
  }
  editColor() {
    if(this.cateId && this.productId){
    this.loader = true;
    if (this.name) {
      this.name = this.name.toUpperCase();
    }
    this.item.name = this.name;
    this.item.code = this.code;
    this.item.activeInd = this.activeInd;    
    this.item.purchaseCategoryId = this.cateId;
    this.item.productId = this.productId;    
    this.service.updatecolor(this.id, this.item).subscribe(res => {
      this.loader = false;
      this.handler.res("Color Updated Successfully");
      this.router.navigate(['/manage-color'])
    },
      err => {
        this.loader = false;
        this.handler.err(err);

      })
    }else{
      this.handler.err('Please Enter Required Fields')
    }
  }
  cancel() {
    this.router.navigate(['/manage-color']);
  }
  ionViewWillLeave() {
    this.editBool=false;
  }
 
}





